// extracted by mini-css-extract-plugin
export default {"input":"FormInput_input__royQh","error":"FormInput_error__+fJrL"};